// Client-side port of the interval-math used by the API
// (nxstart-api/src/utils/reporting-boundary/boundary-interval.utils.js) to determine which
// reporting-boundary months are enabled and which boundaries are "relevant" to a selected date
// range. Kept intentionally tiny and dependency-free so it can be reasoned about independently
// of the server copy — the server is still the source of truth/enforcement (see
// esg-report-preview.service.js), this is only used to drive the Report Preview filter UI.

const toMonthIndex = ({ year, month }) => year * 12 + (month - 1);

const toBoundaryIndexes = (boundary) => ({
  startIndex: toMonthIndex({
    year: boundary.startYear,
    month: boundary.startMonth,
  }),
  endIndex: toMonthIndex({ year: boundary.endYear, month: boundary.endMonth }),
});

// Raw (unmerged) boundaries whose own range overlaps the given range — the "relevant boundaries"
// for a given selected date range. Returns all boundaries when no range is given (e.g. before the
// user has picked a date).
export const boundariesOverlappingRange = (boundaries = [], range) => {
  if (!range) return boundaries || [];
  const { startIndex: rangeStart, endIndex: rangeEnd } =
    toBoundaryIndexes(range);
  return (boundaries || []).filter((boundary) => {
    const { startIndex, endIndex } = toBoundaryIndexes(boundary);
    return startIndex <= rangeEnd && endIndex >= rangeStart;
  });
};

// Builds a Set of "YYYY-MM" keys covered by any of the given enabled intervals, for the
// PreviewYearMonthPicker's gap-month disabling.
export const buildEnabledMonthSet = (enabledIntervals = []) => {
  const set = new Set();
  (enabledIntervals || []).forEach((interval) => {
    const { startIndex, endIndex } = toBoundaryIndexes(interval);
    for (let index = startIndex; index <= endIndex; index += 1) {
      const year = Math.floor(index / 12);
      const month = (index % 12) + 1;
      set.add(
        `${String(year).padStart(4, "0")}-${String(month).padStart(2, "0")}`,
      );
    }
  });
  return set;
};
